import { colors } from '../../utils'

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
    marginTop: '8px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
  },
  addButton: {
    '&.MuiIconButton-root': {
      backgroundColor: colors.disabledBorder,
    },
  },
  label: {
    fontWeight: 500,
  },
  hint: {
    display: 'block',
  },
  errors: {
    display: 'flex',
    flexDirection: 'column',
  },
  errorText: {
    display: 'block',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  thumb: {
    position: 'relative',
    width: '100px',
    height: '100px',
  },
  thumbImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '4px',
    border: `1px solid ${colors.disabledBorder}`,
  },
  removeButton: {
    '&.MuiIconButton-root': {
      position: 'absolute',
      top: '-10px',
      right: '-10px',
      backgroundColor: colors.white,
      width: '22px',
      height: '22px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      '&:hover': {
        backgroundColor: colors.white,
      },
    },
  },
}

export default styles
